<template>
  <div>
  <v-dialog max-width="1400" persistent v-model="modalConfiguracao" transition="dialog-bottom-transition" :z-index="1500">
    <v-card class="configuracao-agenda-modal mx-auto" :loading="carregando ? 'success' : null" :disabled="carregando" color="white">
      <!-- Header moderno -->
      <div class="modal-header">
        <div class="header-content">
          <div class="header-icon">
            <v-icon size="28" color="white">mdi-cog</v-icon>
          </div>
          <div class="header-text">
            <h2 class="header-title">Configurações da Agenda</h2>
            <p class="header-subtitle">Configure e gerencie sua agenda</p>
          </div>
        </div>
        <v-btn icon dark class="close-btn" @click="cancelar()" :loading="carregando">
          <v-icon size="24">mdi-close</v-icon>
        </v-btn>
      </div>

      <!-- Tabs modernas -->
      <div class="tabs-container">
        <v-tabs show-arrows v-model="tabActive" active-class="modern-tab-active" class="modern-tabs">
          <v-tab class="modern-tab">
            <v-icon left>mdi-information</v-icon>
            Geral
          </v-tab>
          <v-tab v-show="permiteCadastroHorarios" class="modern-tab">
            <v-icon left>mdi-clock-time-eight</v-icon>
            Horários
          </v-tab>
          <v-tab v-show="permiteCadastroBloqueios" class="modern-tab">
            <v-icon left>mdi-timer-cancel</v-icon>
            Bloqueios
          </v-tab>
          <v-tab v-show="permiteCadastroBloqueios" class="modern-tab">
            <v-icon left>mdi-clock-remove</v-icon>
            Bloqueios de Horário
          </v-tab>
          <v-tab v-show="permiteCadastroFeriados" class="modern-tab">
            <v-icon left>mdi-beach</v-icon>
            Feriados
          </v-tab>
          <v-tab v-show="permitirCrudUsuarioComAcesso" class="modern-tab">
            <v-icon left>mdi-account-group</v-icon>
            Usuários com Acesso
          </v-tab>
        </v-tabs>
      </div>
      <!-- Card unificado com conteúdo -->
      <div class="unified-content">
        <v-card class="unified-card" flat>
          <v-tabs-items v-model="tabActive">
            <validation-observer ref="observer" v-slot="{}">
              <form @submit.prevent="salvar">
                <!-- GERAL -->
                <v-tab-item>
                  <v-card-text class="form-content">
                <v-row>
                  <v-col cols="12" md="12" sm="12">
                    <soi-input disabled :name="'Proprietário'" v-model="agenda.usuario.nomeCompleto"
                      :label="'Proprietário '" :rules="{ required: true }"></soi-input>
                  </v-col>
                  <v-col cols="12" md="12" sm="12">
                    <soi-input :name="'Descrição'" :label="'Descrição '" v-model="agenda.descricao"
                      :placeholder="'Descrição'" :disabled="false" :rules="{ required: true }"></soi-input>
                  </v-col>
                  <v-col cols="12" md="3" sm="4">
                    <soi-select :label="'Visualização'" :items="enumTipoVisualizacao"
                      v-model="agenda.tipoVisualizacao"></soi-select>
                  </v-col>
                  <v-col cols="12" md="2" sm="4">
                    <soi-input type="number" v-model="agenda.quantidadeFaltasPermitidas" :name="'Faltas Permitidas'"
                      :label="'Faltas Permitidas '" :rules="{ required: true }"></soi-input>
                  </v-col>
                  <!-- Esse trecho por hora foi comentado pois futuramente será usado novamente
                  <v-col cols="12" md="3" sm="4">
                    <soi-switch v-model="agenda.avisarPaciente" :name="'check-button'"
                      :label="'Aviso para pacientes'"></soi-switch>
                  </v-col>
                -->
                  <!-- Esse trecho por hora foi comentado pois futuramente será usado novamente
                  <v-col cols="12" md="4" sm="4">
                    <soi-switch v-model="agenda.criarAgendamentoPartirMiniAgenda" :name="'check-button'"
                      :label="'Criar agendamento pela Mini Agenda'"></soi-switch>
                  </v-col>
                -->
                  <v-col cols="12">
                    <v-checkbox
                      v-model="agenda.usarMensagemPersonalizadaConfirmacao"
                      hide-details
                      class="mt-0"
                    >
                      <template v-slot:label>
                        <span>Utilizar mensagem de confirmação personalizada</span>
                        <v-btn
                          icon
                          small
                          class="ml-2"
                          @click.stop="modalAjudaMensagemConfirmacao = true"
                          :title="'Como usar a mensagem personalizada?'"
                        >
                          <v-icon color="primary">mdi-help-circle-outline</v-icon>
                        </v-btn>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col v-if="agenda.usarMensagemPersonalizadaConfirmacao" cols="12">
                    <v-textarea
                      v-model="agenda.mensagemPersonalizadaConfirmacao"
                      label="Mensagem personalizada"
                      :placeholder="placeholderMensagemConfirmacao"
                      outlined
                      counter="300"
                      maxlength="300"
                      rows="4"
                      :rules="[
                        v => !!v || 'A mensagem personalizada é obrigatória quando habilitada.',
                        v => (v && v.length <= 300) || 'Máximo de 300 caracteres.'
                      ]"
                      :hint="hintMensagemConfirmacao"
                      persistent-hint
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-tab-item>

                <!-- Horarios -->
                <v-tab-item>
                  <v-card-text class="form-content">
                    <soiHorarioAgenda v-model="agenda.listaHorarios" :agendaId="idAgenda">
                    </soiHorarioAgenda>
                  </v-card-text>
                </v-tab-item>

                <!-- Bloqueios -->
                <v-tab-item>
                  <v-card-text class="form-content">
                    <soiBloqueioAgenda v-model="agenda.listaBloqueios" :agenda="agenda">
                    </soiBloqueioAgenda>
                  </v-card-text>
                </v-tab-item>

                <!-- Bloqueios de Horário Específico -->
                <v-tab-item>
                  <v-card-text class="form-content">
                    <soiBloqueioHorarioEspecificoAgenda v-model="agenda.listaBloqueiosHorariosEspecificos" :agenda="agenda">
                    </soiBloqueioHorarioEspecificoAgenda>
                  </v-card-text>
                </v-tab-item>

                <!-- Feriados -->
                <v-tab-item>
                  <v-card-text class="form-content">
                    <soiFeriadoAgenda v-model="agenda.listaFeriados" :agenda="agenda"></soiFeriadoAgenda>
                  </v-card-text>
                </v-tab-item>

                <!-- Usuarios com Acesso -->
                <v-tab-item eager>
                  <v-card-text class="form-content">
                    <soiUsuarioPermissao v-model="agenda.agendasUsuarios" :agenda="agenda"></soiUsuarioPermissao>
                  </v-card-text>
                </v-tab-item>

            <!-- Avisos -->
             <!-- Esse trecho por hora foi comentado pois futuramente será usado novamente
            <v-tab-item>
              <v-card-text class="mt-3">
                <soiConfiguracaoAviso v-model="agenda.listaConfiguracaoAviso"></soiConfiguracaoAviso>
              </v-card-text>
            </v-tab-item>
          -->
            <!--Agendamento Online Esse trecho por hora foi comentado pois futuramente será usado novamente
            <v-tab-item eager>
              <v-card-text class="mt-3">
                <soi-agendamento-online :descricao="agenda.descricao" :idAgenda="agenda.id"></soi-agendamento-online>
              </v-card-text>
            </v-tab-item>
          -->
                <!-- Ações do formulário -->
                <div class="form-actions">
                  <div class="actions-container">
                    <v-btn color="warning" @click="fecharModal()" :loading="carregando" class="action-btn cancel-btn">
                      <v-icon left>mdi-keyboard-return</v-icon>
                      Voltar
                    </v-btn>
                    <v-btn id="salvar" type="submit" color="success" :loading="carregando" :disabled="carregando" class="action-btn save-btn">
                      <v-icon left>$saveIcon</v-icon>
                      Salvar
                    </v-btn>
                  </div>
                </div>
              </form>
            </validation-observer>
          </v-tabs-items>
        </v-card>
      </div>
    </v-card>
  </v-dialog>

  <AjudaMensagemConfirmacaoModal
    v-model="modalAjudaMensagemConfirmacao"
  />
  </div>
</template>

<script lang="ts">
import DateHelper from '../../helpers/DateHelper';
import {
  AlertaPerguntaSimOuNaoBooleano,
  AlertaSimplesErro,
  MensagemMixin,
} from '../../helpers/MensagemHelper';
import Agenda from '../../models/agenda/Agenda';
import ConfiguracaoAviso from '../../models/agenda/ConfiguracaoAviso';
import { TipoVisualizacao } from '../../models/Enums';
import { AgendaService } from '../../services/AgendaService';
import { UsuarioService } from '../../services/UsuarioService';
import Vue from 'vue';
import AjudaMensagemConfirmacaoModal from './AjudaMensagemConfirmacaoModal.vue';
import soiHorarioAgenda from './HorarioConfiguracao.vue';
import soiBloqueioAgenda from './BloqueioConfiguracao.vue';
import soiBloqueioHorarioEspecificoAgenda from './BloqueioHorarioEspecificoConfiguracao.vue';
import soiFeriadoAgenda from './FeriadoConfiguração.vue';
import soiConfiguracaoAviso from './ConfiguracaoAviso.vue';
import soiUsuarioPermissao from './PermissaoAgenda.vue';
import soiAgendamentoOnline from './AgendamentoOnline.vue';
import { decode, getToken } from '../../utils/Token';
import Role from '@/constants/enums/Role';

export default Vue.component('soi-agenda-configuracao', {
  name: 'AgendaConfiguracao',
  components: {
    soiHorarioAgenda,
    soiBloqueioAgenda,
    soiBloqueioHorarioEspecificoAgenda,
    soiFeriadoAgenda,
    soiUsuarioPermissao,
    AjudaMensagemConfirmacaoModal,
  },
  data() {
    // Strings com {{ }} no template quebram o compilador Vue; ficam no data como literais JS.
    const ph = '{{paciente.Nome}}';
    const md = '{{medico.Nome}}';
    const cl = '{{clinica.Nome}}';
    const dt = '{{data}}';
    const hr = '{{hora}}';
    const lk = '{{link}}';
    const ag = '{{agenda.Descricao}}';
    return {
      placeholderMensagemConfirmacao: `Ex: Olá ${ph}, sua consulta com ${md} na ${cl} é dia ${dt} às ${hr}. Confirme aqui: ${lk}`,
      hintMensagemConfirmacao: `Campos disponíveis: ${ph}, ${md}, ${cl}, ${dt}, ${hr}, ${lk}, ${ag}`,
      modalAjudaMensagemConfirmacao: false,
      selected: null,
      carregando: false,
      responseOk: false,
      agenda: new Agenda(),
      editarConfiguracao: false,
      configuracaoAviso: new ConfiguracaoAviso(),
      serviceAgenda: new AgendaService(),
      tabActive: null,
      usuarioService: new UsuarioService(),
      carregandoBuscarUsuario: false,
      service: new AgendaService(),
      enumTipoVisualizacao: TipoVisualizacao,
      validGeral: true,
      idAgenda: parseInt(this.$route.params.id, 10),
      modalHide: false,
      modalConfiguracao: false,
      agendaModalConfiguracao: new Agenda(),
      agendaSalvar: Agenda,
      valid: true,
    };
  },
  computed: {
    permitirCrudUsuarioComAcesso() {
      const idToken = decode(getToken()).id;
      const roleUsuario = decode(getToken()).role;

      if (roleUsuario === Role.Admin || roleUsuario === Role.Administrador || roleUsuario === Role.AdminMedico) {
        return true;
      }

      return idToken === this.agenda.usuarioId;
    },
    permiteCadastroHorarios() {
      const idToken = decode(getToken()).id;
      const roleUsuario = decode(getToken()).role;

      if (roleUsuario === Role.Admin || roleUsuario === Role.Administrador || roleUsuario === Role.AdminMedico) {
        return true;
      }

      if (idToken === this.agenda.usuarioId) {
        return true;
      }
      if (this.agenda.agendasUsuarios.find((x: { usuarioId: string; }) => x.usuarioId === idToken)) {
        return this.agenda.agendasUsuarios.find((x: { usuarioId: string; }) => x.usuarioId === idToken).permiteCadastroHorarios;
      }

      return false;
    },
    permiteCadastroFeriados() {
      const idToken = decode(getToken()).id;
      const roleUsuario = decode(getToken()).role;

      if (roleUsuario === Role.Admin || roleUsuario === Role.Administrador || roleUsuario === Role.AdminMedico) {
        return true;
      }

      if (idToken === this.agenda.usuarioId) {
        return true;
      }
      if (this.agenda.agendasUsuarios.find((x: { usuarioId: string; }) => x.usuarioId === idToken)) {
        return this.agenda.agendasUsuarios.find((x: { usuarioId: string; }) => x.usuarioId === idToken).permiteCadastroFeriados;
      }

      return false;
    },
    permiteCadastroBloqueios() {
      const idToken = decode(getToken()).id;
      const roleUsuario = decode(getToken()).role;

      if (roleUsuario === Role.Admin || roleUsuario === Role.Administrador || roleUsuario === Role.AdminMedico) {
        return true;
      }

      if (idToken === this.agenda.usuarioId) {
        return true;
      }
      if (this.agenda.agendasUsuarios.find((x: { usuarioId: string; }) => x.usuarioId === idToken)) {
        return this.agenda.agendasUsuarios.find((x: { usuarioId: string; }) => x.usuarioId === idToken).permiteCadastroBloqueios;
      }

      return false;
    },
    permiteCadastroAvisos() {
      const idToken = decode(getToken()).id;
      const roleUsuario = decode(getToken()).role;

      if (roleUsuario === Role.Admin || roleUsuario === Role.Administrador || roleUsuario === Role.AdminMedico) {
        return true;
      }

      if (idToken === this.agenda.usuarioId) {
        return true;
      }
      if (this.agenda.agendasUsuarios.find((x: { usuarioId: string; }) => x.usuarioId === idToken)) {
        return this.agenda.agendasUsuarios.find((x: { usuarioId: string; }) => x.usuarioId === idToken).permiteCadastroAvisos;
      }

      return false;
    },
  },
  methods: {
    async abrirModalConfiguracao(idAgenda: number) {
      this.idAgenda = idAgenda;
      this.modalConfiguracao = true;
      this.agenda = new Agenda();
      this.carregando = true;

      await this.serviceAgenda.Get(idAgenda)
        .then(
          (res: any) => {
            this.agenda = res.data;
            this.carregando = false;
            this.agenda.listaBloqueios.forEach((bloqueio: { dataInicio: string; dataFim: string; }) => {
              // eslint-disable-next-line no-param-reassign
              bloqueio.dataInicio = DateHelper.formataParaDiaMesAno(bloqueio.dataInicio);
              // eslint-disable-next-line no-param-reassign
              bloqueio.dataFim = DateHelper.formataParaDiaMesAno(bloqueio.dataFim);
            });
            this.agenda.listaBloqueiosHorariosEspecificos.forEach((bloqueio: { data: string; id: number }) => {
              if (bloqueio.data && bloqueio.data.includes('T')) {
                // eslint-disable-next-line no-param-reassign, prefer-destructuring
                bloqueio.data = bloqueio.data.split('T')[0];
              }
            });
            this.agenda.listaFeriados.forEach((feriado: { data: string; }) => {
              feriado.data = DateHelper.formataParaDiaMesAno(feriado.data);
            });
          },
          (err: any) => {
            this.carregando = false;
            AlertaSimplesErro('Aviso:', err);
          },
        );
    },
    cancelar() {
      this.fecharModal();
    },
    async salvar() {
      try {
        this.carregando = true;
        const agendaSalvar: Agenda = JSON.parse(JSON.stringify(this.agenda));
        agendaSalvar.listaBloqueios.forEach((bloqueio) => {
          bloqueio.dataInicio = DateHelper.formataParaAnoMesDiaISO8601(bloqueio.dataInicio);
          bloqueio.dataFim = DateHelper.formataParaAnoMesDiaISO8601(bloqueio.dataFim);
        });
        agendaSalvar.listaBloqueiosHorariosEspecificos.forEach((bloqueio) => {
          if (bloqueio.data && !bloqueio.data.includes('T')) {
            if (bloqueio.data.includes('-') && bloqueio.data.split('-')[0].length === 4) {
              const [ano, mes, dia] = bloqueio.data.split('-');
              bloqueio.data = DateHelper.formataParaAnoMesDiaISO8601(`${dia}/${mes}/${ano}`);
            } else {
              bloqueio.data = DateHelper.formataParaAnoMesDiaISO8601(bloqueio.data);
            }
          }
          if (!bloqueio.agendaId) {
            bloqueio.agendaId = agendaSalvar.id;
          }
        });
        agendaSalvar.listaFeriados.forEach((feriado) => {
          // eslint-disable-next-line no-param-reassign
          feriado.data = DateHelper.formataParaAnoMesDiaISO8601(feriado.data);
        });
        await this.service.Put(agendaSalvar.id, agendaSalvar)
          .then(
            (res: { data: any; }) => {
              this.agenda = res.data;
              MensagemMixin(3000, 'success', 'Configurações de Agenda salvas com sucesso.');
              this.$emit('atualizaConfiguracao');
              this.responseOk = true;
            },
            (err: any) => {
              AlertaSimplesErro('Aviso:', err);
              this.responseOk = false;
            },
          );

        if (this.responseOk) {
          this.modalConfiguracao = false;
          this.$emit('atualizaAgenda');
        }

        this.carregando = false;
      } catch (error) {
        this.carregando = false;
        console.error(error);
      }
    },
    async fecharModal() {
      if (await AlertaPerguntaSimOuNaoBooleano('Se você sair, perderá seus dados não salvos.', 'Deseja sair?')) {
        this.modalConfiguracao = false;
      }
    },
  },
});
</script>
<style>
/* HEADER LIMPO E MINIMALISTA */
.modal-header {
  background: var(--especialidade-gradient, #2e4b9d) !important;
  padding: 24px 32px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
}

.header-content {
  display: flex !important;
  align-items: center !important;
  gap: 16px !important;
}

.header-text {
  color: white !important;
}

.header-title {
  font-size: 24px !important;
  font-weight: 700 !important;
  margin: 0 !important;
  color: white !important;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3) !important;
}

.header-subtitle {
  font-size: 14px !important;
  margin: 4px 0 0 0 !important;
  color: rgba(255,255,255,0.9) !important;
  font-weight: 400 !important;
}

.close-btn {
  transition: all 0.3s ease !important;
}

.close-btn:hover {
  opacity: 0.8 !important;
}


.v-icon{
  margin: 0 !important;
}


/* TABS MODERNAS */
.modern-tabs {
  background: transparent !important;
}

.modern-tabs .v-tabs-bar {
  background: transparent !important;
  height: 56px !important;
}

.modern-tabs .v-tabs-bar__content {
  height: 56px !important;
}

.modern-tab {
  color: var(--especialidade-primary, #2e4b9d) !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  min-height: 56px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-center !important;
  transition: all 0.3s ease !important;
  font-size: 13px !important;
  background: white !important;
  border-radius: 8px 8px 0 0 !important;
  margin: 0 4px !important;
}

.modern-tab .v-icon {
  margin-right: 8px !important;
  color: var(--especialidade-primary) !important;
}

.modern-tab:hover {
  color: var(--especialidade-secondary) !important;
  background: rgba(255,255,255,0.9) !important;
  transform: translateY(-1px) !important;
}

.modern-tab .v-tab__content {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
}

.modern-tab .v-tab__content .v-tab__wrapper {
  color: inherit !important;
}

.modern-tab .v-tab__content .v-tab__wrapper .v-tab__text {
  color: inherit !important;
  font-size: inherit !important;
  font-weight: inherit !important;
}

.v-dialog.v-dialog--active.v-dialog--persistent {
  box-shadow: none !important;
  border-radius: 20px !important;
}

.v-dialog.v-dialog--active.v-dialog--persistent .v-card {
  border-radius: 20px !important;
  overflow: hidden !important;
}

/* CARD UNIFICADO */

.unified-card {
  background: white !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08) !important;
  border: 1px solid #e9ecef !important;
  overflow: hidden !important;
}

/* CONTEÚDO DO FORMULÁRIO */
.form-content {
  padding: 32px !important;
  background: white !important;
}

/* CAMPOS DO FORMULÁRIO */
.v-text-field, .v-select, .v-textarea {
  background: white !important;
  border-radius: 8px !important;
}

.v-text-field .v-input__control .v-input__slot,
.v-select .v-input__control .v-input__slot,
.v-textarea .v-input__control .v-input__slot {
  border-radius: 8px !important;
  border: 1px solid #e9ecef !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05) !important;
}

.v-text-field .v-input__control .v-input__slot:focus-within,
.v-select .v-input__control .v-input__slot:focus-within,
.v-textarea .v-input__control .v-input__slot:focus-within {
  border-color: var(--especialidade-primary, #2e4b9d) !important;
  box-shadow: 0 0 0 3px rgba(46, 75, 157, 0.1) !important;
}

/* AÇÕES DO FORMULÁRIO */
.form-actions {
  padding: 24px 32px !important;
  background: #f8f9fa !important;
  border-top: 1px solid #e9ecef !important;
  margin-top: 0 !important;
}

.actions-container {
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center !important;
  gap: 12px !important;
}

.action-btn {
  border-radius: 8px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  padding: 12px 24px !important;
  min-width: 120px !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
  transition: all 0.3s ease !important;
}

.action-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 16px rgba(0,0,0,0.15) !important;
}

.cancel-btn {
  background: #6c757d !important;
  color: white !important;
}

.cancel-btn:hover {
  background: #5a6268 !important;
}

.save-btn {
  background: #28a745 !important;
  color: white !important;
}

.save-btn:hover {
  background: #218838 !important;
}

/* RESPONSIVIDADE */
@media (max-width: 768px) {
  .configuracao-agenda-modal {
    margin: 16px !important;
    max-width: calc(100vw - 32px) !important;
  }

  .modal-header {
    padding: 20px 24px !important;
  }

  .header-title {
    font-size: 20px !important;
  }

  .header-subtitle {
    font-size: 13px !important;
  }

  .unified-content {
    padding: 0 24px !important;
  }

  .form-content {
    padding: 24px !important;
  }

  .form-actions {
    padding: 20px 24px !important;
  }

  .actions-container {
    flex-direction: column !important;
    align-items: stretch !important;
  }

  .action-btn {
    width: 100% !important;
    margin-bottom: 8px !important;
  }
}

@media (max-width: 480px) {
  .header-content {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 12px !important;
  }
}

/* ANIMAÇÕES */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.configuracao-agenda-modal {
  animation: fadeInUp 0.4s ease-out !important;
}

.unified-card {
  animation: fadeInUp 0.5s ease-out 0.1s both !important;
}

.form-actions {
  animation: fadeInUp 0.6s ease-out 0.2s both !important;
}
</style>
